import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#f6f6f7',
    color100: '#ededee',
    color200: '#dbdcdd',
    color300: '#c9cacc',
    color400: '#96989b',
    color500: '#63656a',
    color600: '#4f5155',
    color700: '#3b3d40',
    color800: '#28282a',
    color900: '#141415'
  },
  default: {
    color50: '#dddddd',
    color100: '#bbbbbb',
    color200: '#999999',
    color300: '#777777',
    color400: '#555555',
    color500: '#333333',
    color600: '#292929',
    color700: '#1f1f1f',
    color800: '#141414',
    color900: '#0a0a0a'
  },
  accent: {
    color50: '#fffad9',
    color100: '#fff5b3',
    color200: '#fff08d',
    color300: '#ffea66',
    color400: '#ffe540',
    color500: '#ffe01a',
    color600: '#ccb315',
    color700: '#998610',
    color800: '#665a0a',
    color900: '#332d05'
  },
  positive: {
    color50: '#ebf4d5',
    color100: '#d6e9aa',
    color200: '#c2de80',
    color300: '#add355',
    color400: '#99c82b',
    color500: '#84bd00',
    color600: '#6a9700',
    color700: '#4f7100',
    color800: '#354c00',
    color900: '#1a2600'
  },
  negative: {
    color50: '#ffead5',
    color100: '#ffd5aa',
    color200: '#ffc180',
    color300: '#ffac55',
    color400: '#ff972b',
    color500: '#ff8200',
    color600: '#cc6800',
    color700: '#994e00',
    color800: '#663400',
    color900: '#331a00'
  },
  special: {
    color50: '#d5edf4',
    color100: '#aadbe9',
    color200: '#80c9de',
    color300: '#55b6d2',
    color400: '#2ba4c7',
    color500: '#0092bc',
    color600: '#007596',
    color700: '#005871',
    color800: '#003a4b',
    color900: '#001d26'
  }
};

const variant: ACPVariant = {
  id: 'www.wunetspendprepaid.com',
  productTitle: 'Western Union Netspend Prepaid Account',
  productType: 'gpr',
  accessDomain: {
    subdomain: 'www',
    domain: 'wunetspendprepaid',
    topLevelDomain: 'com'
  },
  colors,
  logoOverrides: [
    {
      file: 'logo.mobile.svg',
      mobile: true
    },
    {
      file: 'logo.svg'
    }
  ],
  legacyAcpTheme: 'wu',
  legacyAcpBrandName: 'westernuniongpr',
  legacyLegosTheme: 'wu',
  status_bar_background_color: '#000000',
  status_bar_foreground_color: 'light',
  themeConfiguration: {
    acpLoginTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpDynamicFaqTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpEsignTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpSecureUploadTheme: {
      overrideLinkColor: colors.special.color500
    },
    acpUnAuthLayout: {
      overrideLinkColor: colors.special.color500
    },
    acpHandOffTheme: {
      overrideLinkColor: colors.special.color500
    }
  },
  contactInfo: {
    name: 'Western Union Netspend Prepaid',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@wunetspendprepaid.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(800) 214-5483',
    phone: '8002145483',
    phone_international: '737-220-8956',
    balance_check_phone: '18002145483',
    balance_check_phone_formatted: '1-800-214-5483',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: '2d8c6147-f9d2-45e3-9b49-7049bc7d9cb2',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: false,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: true,
      showReloadLocationLink: true
    },
    misc: {
      distributor: 'westernuniongpr',
      layoutComponentOverride: false,
      loader: 'generic',
      storeNameOverride: 'WesternUnion',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#333333',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.wunetspendprepaid.com',
      marketingSiteLinkText: 'wunetspendprepaid.com',
      locationSearchMax: '25',
      iOSAppId: '894666682'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today."
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'lean-dispute',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
